var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconErrorFatal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6244 22L17.404 1.3C16.9032 0.5 16.0017 0 15 0C13.9983 0 13.0968 0.5 12.596 1.3L0.375626 22C-0.125209 22.8 -0.125209 23.8 0.375626 24.7C0.876461 25.5 1.6778 26 2.67947 26H27.2204C28.222 26 29.1235 25.5 29.6244 24.7C30.1252 23.8 30.1252 22.9 29.6244 22ZM27.02 23.2H2.97997L15 3L27.02 23.2Z",
    fill: "#A2001D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5977 10.1V16.1C13.5977 16.9 14.2988 17.5 15 17.5C15.7012 17.5 16.4023 16.9 16.4023 16.1V10.1C16.4023 9.30001 15.7012 8.70001 15 8.70001C14.2988 8.70001 13.5977 9.30001 13.5977 10.1Z",
    fill: "#A2001D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.8C14.1987 18.8 13.5977 19.4 13.5977 20.2C13.5977 21 14.2988 21.6 15 21.6C15.7012 21.6 16.4023 21 16.4023 20.2C16.4023 19.4 15.8013 18.8 15 18.8Z",
    fill: "#A2001D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorFatal);
export default __webpack_public_path__ + "static/media/icon_error_fatal.cb34a7123a95d8a30e81dd76a26c184f.svg";
export { ForwardRef as ReactComponent };